<template>
  <div class="article-list">
    <ul>
      <li class="article-item" v-for="item in articleList" :key="item.id">
        <a href="javascript:void(0);" @click="itemClick(item)">
          <span class="tag" v-show="showCopyRight">[{{item.copyright}}]</span>
          <span class="title">{{item.title}}</span>
          <span class="time">{{item[articleTime]}}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      articleList: {
        type: Array,
        required: true
      },
      showCopyRight: {
        type: Boolean
      },
      articleTime: {
        type: String,
        default: 'auditDate'
      }
    },
    methods: {
      itemClick (item) {
        this.$emit('item-click', item)
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  @import '../../stylus/mixin'
  .article-list
    border-radius 5px
    overflow hidden
    box-shadow 0px 1px 15px 3px rgba(0, 0, 0, 0.16)
    ul
      list-style none
      padding 0
      margin 0
    .article-item
      font-size 0
      height 66px
      line-height 66px
      border-top 1px solid rgb(230, 235, 241)
      &:nth-child(0)
        border-top none
      a
        display block
        width 100%
        height 100%
        background-color #fff
        &:hover
          background-color #f5f7fa
      span
        color #333
        height 66px
        display inline-block
        font-size 14px
      .tag
        width 50px
        float left
        font-weight bold
        margin-left 46px
      .title
        margin-left 48px
        float left
        width 570px
        ellipsis()
      .time
        width 90px
        float right
        margin-right 67px
</style>



// WEBPACK FOOTER //
// article-list.vue?11279a30